import { render, staticRenderFns } from "./caseItemCom.vue?vue&type=template&id=73f77fde&scoped=true"
import script from "./caseItemCom.vue?vue&type=script&lang=js"
export * from "./caseItemCom.vue?vue&type=script&lang=js"
import style0 from "./caseItemCom.vue?vue&type=style&index=0&id=73f77fde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f77fde",
  null
  
)

export default component.exports